import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { withRouter } from 'react-router';
import * as SurveyStateController from '../../../store/StateControllers/Survey/SurveyStateController';
import * as Models from '../../../store/Models/Surveys/SurveyDataModel';
import "./../styles.css";
import { SurveyProps } from '../CreateAndEditSurveys';
import { ToxnotSignInRequiredComponent } from '../../core/BaseApplicationComponents/ToxnotSignInRequiredComponent';
import { TeamRole } from '../../../store/Models/UserContext';


class CreateAndEditSurveyNotesPage extends ToxnotSignInRequiredComponent<SurveyProps>{
    protected renderConcreteComponent() {
        return (
            <div id="notes-root">
                {this.props.appServices.userContext?.isEditor &&
                    <React.Fragment>
                        <div className="form-group">
                            <textarea id="note-message" className="form-control" rows={5} placeholder="" />
                        </div>
                        <div className="form-group">
                            <button type="button" id="add-note-button" onClick={e => this.addNote(e)} className="btn btn-sm btn-toxnot-primary">{this.localizeString("Add Note")}</button>
                        </div>
                    </React.Fragment>
                }
                <table id="notes-table" className="table toxnot-table-v2">
                    <thead>
                        <tr>
                            <td><a role="button">{this.localizeString("Note")}</a></td>
                            <td><a role="button">{this.localizeString("Posted By")}</a></td>
                            <td><a role="button">{this.localizeString("Date")}</a></td>
                            <td><a role="button">{this.localizeString("Actions")}</a></td>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.surveyRequest.notes.map((data, i) => {
                            return (
                                <tr key={i.toString()}>
                                    <td><textarea rows={4} className="form-control" onChange={e => this.props.editNote(i, e.target.value)} value={data.note ?? ""}></textarea></td>
                                    <td>{data.posterName + "(" + data.posterEmail + ")"}</td>
                                    <td>{new Date(data.dateTimePosted).toLocaleDateString()}</td>
                                    <td>{this.props.appServices.userContext?.isEditor && <button type="button" onClick={e => this.props.setSurveyRequestData({
                                        notes: this.props.surveyRequest.notes.filter((v, index) => index !== i)
                                    })} className="btn btn-sm btn-danger" data-index={i}><span className="glyphicon glyphicon-remove"></span></button>}</td>
                                </tr>);
                        })}
                    </tbody>
                </table>
                {this.props.surveyRequest.notes.length === 0 && <p>{this.localizeString("There are no notes yet")}</p>}
            </div>
        );
    }

    // ===============================================================================

    protected override getDisallowedRoles() {
        return [TeamRole.Marketing];
    }
    // ==========================================================================

    private addNote(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        const message = $("#note-message").val()?.toString() ?? "";
        const newNote: Models.SurveyRequestNote = {
            ownerId: null,
            requestId: this.props.surveyRequest.requestId,
            dateTimePosted: new Date().toISOString(),
            posterName: this.props.appServices.userContext?.fullName ?? "",
            posterEmail: this.props.appServices.userContext?.emailAddress ?? "",
            note: message ?? ""
        };
        this.props.setSurveyRequestData({ notes: this.props.surveyRequest.notes.concat(newNote) });

        $("#note-message").val("");
    }
    
}


export default connect(
    (state: ApplicationState) => ({ ...state.createAndEditSurveysState, appServices: state.appServices }),
    SurveyStateController.actionCreators
)(withRouter(CreateAndEditSurveyNotesPage) as any);